import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import RootStore, { ROOT_STORE } from 'src/stores/rootStore';

interface IFooterComponentInjectedProps {
  [ROOT_STORE]: RootStore;
}

interface IMenuData {
  name: string;
  index: number;
  isActive: boolean;
  url: string;
  isExternal: boolean;
  replace?: boolean;
  hidden?: boolean;
}

const FooterComponent = inject(ROOT_STORE)(observer((props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { rootStore: { layoutStore, authenticateStore } } = props as IFooterComponentInjectedProps;
  const activatedIndex = layoutStore.activeFooterItemIndex;
  const isFacilityAdmin = authenticateStore.isFacilityAdminOnly;

  const menuData: IMenuData[] = [
    { name: 'main', index: 0, isActive: false, url: '/', isExternal: false },
    { name: 'feed', index: 1, isActive: false, url: '/feeds', isExternal: false, replace: history.location.pathname === '/feeds' },
    { name: 'program', index: 2, isActive: false, url: '/program', isExternal: false },
    { name: 'my', index: 3, isActive: false, url: '/mySetting', isExternal: false }
  ];

  menuData[activatedIndex].isActive = true;

  // Facility Admin이면 main, my 자리는 유지하고 feed, program만 숨김 (DOM 순서/아이콘 매핑 유지)
  const visibleMenuData = isFacilityAdmin
    ? menuData.map(item => ({
        ...item,
        hidden: item.name !== 'main' && item.name !== 'my'
      }))
    : menuData.map(item => ({ ...item, hidden: false }));

  return (
    layoutStore.isVisibilityFooterNavigation ?
      <React.Fragment>
        <div className='btm-mt' />
        <div id='btm_fix_menu'>
          <ul className='btm-menu'>
            {
              visibleMenuData.map(item => (
                <li
                  key={item.name}
                  className={`${t('image.className')}${item.isActive ? ' activate' : ''}`}
                  style={item.hidden ? { visibility: 'hidden' } : undefined}
                >
                  {item.isExternal && <a href={`${item.url}`}>{item.name}</a>}
                  {!item.isExternal && <Link to={item.url} replace={item.replace}>{item.name}</Link>}
                </li>
              ))
            }
          </ul>
        </div>
      </React.Fragment>
      :
      <></>
  )
}));
export default FooterComponent;


// WEBPACK FOOTER //
// ./src/components/layout/footerComponent.tsx